import { CargoOwnerDocsList } from "components/shared/cargoOwnerDocs";
import React, { Fragment } from "react";

const BidDocuments = ({ documents }) => {
    return (
        <Fragment>
            <div className="show-bid__section-header">Документы</div>
            <div className="show-bid__documents-container">
                <CargoOwnerDocsList documents={documents} />
            </div>
        </Fragment>
    );
};

export default BidDocuments;
